import React, { FC } from 'react';
import styled from 'styled-components';
import OvTable from '../UI/molecules/OvTable';
import { ScanSequenceDataUtils } from '../../common/utils/services/scan-sequence-data-utils';
import { ScanSequence } from '../../common/model/dto/scan-sequences/scan-sequence';
import { useAdminScanSequenceMutations } from '../../hooks/use-admin-scan-sequence-mutations';
import { Resource } from '../../common/model/type/resource.enum';
import useAuthorized from '../../hooks/use-authorized';

const ScanSequenceInfo: FC<{ scanSequence: ScanSequence }> = ({
  scanSequence,
}) => {
  const { updateScanSequence } = useAdminScanSequenceMutations();

  const applicationOperations = useAuthorized(Resource.Application);
  const scanningPlanOperations = useAuthorized(Resource.ScanningPlan);

  const scanningPlanUpdateAllowed =
    scanningPlanOperations.update || applicationOperations.supervise;

  const handleScanSequenceUpdate = (updatedProperties: any) => {
    if (scanSequence?.id) {
      updateScanSequence.mutate({
        scanSequenceId: scanSequence.id,
        updatedProperties: {
          ...updatedProperties,
        },
      });
    }
  };

  return (
    <ContentContainer>
      <OvTable
        data={ScanSequenceDataUtils.mapScanSequenceToTable(scanSequence!)}
        theme="Light"
        onSaveRowValue={handleScanSequenceUpdate}
        editable={scanningPlanUpdateAllowed}
      />
    </ContentContainer>
  );
};

export default ScanSequenceInfo;

const ContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`;
